// eslint-disable-next-line import/no-anonymous-default-export
export default {
    AguardandoAnalise: 1,
    Deferido: 2,
    Indeferido: 3,
    Cancelada: 4
}